import "./../../App.css";
import "./SupportView.css";

import $ from "jquery";
import Alert from "react-bootstrap/Alert";
import Button from "@material-ui/core/Button";
import CheckboxPanel from "../CheckboxPanel/CheckboxPanel";
import ChipsView from "../ChipsView/ChipsView";
import Divider from "@material-ui/core/Divider";
import FileUploader from "../FileUploader/FileUploader";
import React from "react";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import restFormService from "../../services/RestFormService";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  root: {
    backgroundColor: "white",
    color: "white",
    "& .MuiInputBase-root": {
      color: "black",
      fontFamily: "Lato",
      fontWeight: 400,
      borderRadius: "3px",
      boxShadow: "0 2px 0 0 rgba(0,0,0,.1)"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b0b0b0 !important"
    },
    "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px dashed #1c1c1c !important"
    }
  }
});

const ServiceBWTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.black,
    color: "white",
    boxShadow: theme.shadows[1],
    fontSize: 14
  }
}))(Tooltip);

class SupportView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      datenschutz: false,
      send: false,
      active: false,
      nachname: "",
      kommune: "",
      email: "",
      tel: "",
      vorname: "",
      processId: "",
      vornameErrorMsg: "",
      vornameError: true,
      nachnameErrorMsg: "",
      nachnameError: true,
      emailErrorMsg: "",
      emailError: true,
      betreffErrorMsg: "",
      betreffError: false,
      betreff: ""
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateStateCheckbox = this.updateStateCheckbox.bind(this);
    this.handleMandatoryChange = this.checkFieldValue.bind(this);
    this.updateStateEmail = this.updateStateEmail.bind(this);
    this.updateStateDefault = this.updateStateDefault.bind(this);
    this.updateStateBetreffContact = this.updateStateBetreffContact.bind(this);
    this.sendHint = this.sendHint(this);
    this.input = React.createRef();
  }

  componentDidMount() {
    $(".app-alert").css("display", "none");
    $("textarea").attr("maxLength", "2000");
    $("input").attr("maxLength", "150");

    this.setState({
      betreffError: false
    });

    // set language  there is only one at the moment
    document.documentElement.lang = "de";
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  // sends the message to backend
  sendMessageButton = (e) => {
    restFormService(this.state).then((response) => {
      if (response && response.ok) {
        $(".app-alert-success").css("display", "block");
      } else {
        $(".app-alert-failed").css("display", "block");
      }
      this.setState({ send: true });
      this.setState({ active: false });
    });
    window.scrollTo(0, 0);
  };

  sendHint = (e) => {};

  updateStateBetreffContact(event) {
    let hasError = true;
    let name = "betreffContact";
    let errorMsg = "";
    if (event != null) {
      hasError = false;
    } else {
      errorMsg = "Das Feld darf nicht leer sein!";
    }
    this.setState({
      [name + "ErrorMsg"]: errorMsg,
      [name + "Error"]: hasError
      // [name]: value
    });
    if (event == null) this.setState({ betreff: "" });
    else this.setState({ betreff: event.label });
  }

  updateStateCheckbox(datenschutzneu) {
    this.setState({ datenschutz: datenschutzneu });
    if (
      !this.state.send &&
      datenschutzneu &&
      !this.state.nachnameError &&
      !this.state.vornameError &&
      !this.state.emailError &&
      !this.state.betreffError
    ) {
      this.setState({ active: true });
    } else this.setState({ active: false });
  }

  updateStateDefault(event) {
    this.checkFieldValue(event);
    const target = event.target;
    const value = target.value;

    this.setSendingActiveState(value);
  }

  setSendingActiveState(value) {
    if (
      !this.state.send &&
      this.state.datenschutz &&
      value &&
      !this.state.nachnameError &&
      !this.state.vornameError &&
      !this.state.emailError &&
      !this.state.betreffError
    ) {
      this.setState({ active: true });
    } else this.setState({ active: false });
  }

  updateStateEmail(event) {
    this.checkEmailStruct(event);
    const target = event.target;
    const value = target.value;
    this.setSendingActiveState(value);
  }

  onChange = (chips) => {
    this.setState({ chips });
  };

  checkEmailStruct(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let hasError = true;
    let errorMsg = "";

    var regex = /.+@.+\..+/i;
    var found = value.match(regex);
    if (found != null) {
      hasError = false;
    } else {
      errorMsg = "Das Feld muss eine E-Mail-Adresse enthalten!";
    }

    this.setState({
      [name + "ErrorMsg"]: errorMsg,
      [name + "Error"]: hasError,
      [name]: value
    });
  }

  checkFieldValue(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let hasError = true;
    let errorMsg = "";
    // eslint-disable-next-line eqeqeq
    if (value.replace(/\s/g, "") != "") {
      hasError = false;
    } else {
      errorMsg = "Das Feld darf nicht leer sein!";
      //console.log("eerr");
    }
    this.setState({
      [name + "ErrorMsg"]: errorMsg,
      [name + "Error"]: hasError,
      [name]: value
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Alert className="app-alert app-alert-success" variant="success">
          Vielen Dank. Das Formular wurde erfolgreich versendet.
        </Alert>
        <Alert className="app-alert app-alert-failed" variant="danger">
          Das hat leider nicht geklappt. Bitte versuchen Sie es zu einem späteren Zeitpunkt nochmal oder schicken Sie
          eine E-Mail mit der Fehlerbeschreibung an:{" "}
          <a href="mailto:support.ozg-hub@bitbw.bwl.de">support.ozg-hub@bitbw.bwl.de</a>.
        </Alert>
        <h3 className="app-headline">Support</h3>
        <Divider />
        <div className="sbw-def-spacer" />
        <div id="contacttext">
          <Typography
            style={{
              fontSize: "16px",
              color: "black",
              textAlign: "left",
              fontFamily: "Lato",
              fontWeight: 400
            }}
          >
            {" "}
            Für inhaltliche Fragen oder Hinweise zu Ihrem konkreten Antrag wenden Sie sich bitte nur an die zuständige
            Stelle. Beispiele: Sie möchten wissen, wie der Bearbeitungsstand ist oder eine andere Kontonummer mitteilen.
            Bitte haben Sie Verständnis, wenn Informationen dieser Art weder bearbeitet noch an die zuständige Stelle
            weitergeleitet werden.
          </Typography>
        </div>

        <div className="sbw-def-spacer" />
        <Typography
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            color: "black",
            textAlign: "left",
            fontFamily: "Lato"
          }}
        >
          Mit * markierte Eingabefelder sind Pflichtfelder. Ohne diese Angaben können Sie Ihre Nachricht nicht absenden.
        </Typography>
        <div className="sbw-def-spacer" />

        <label className="required" htmlFor="betreffContact">
          Betreff
        </label>
        <div id="containerContactBetreff" className="form-field" data-testid="containerContactBetreff">
          <ChipsView
            id="betreffContact"
            disabled={!this.state.contact}
            name="betreffContact"
            fullWidth
            classes={classes.root}
            value={this.state.betreff}
            update={this.updateStateBetreffContact}
            variant="outlined"
          />
          <div className="errorMsg">{this.state.betreffContactErrorMsg}</div>
        </div>

        <label className="required" htmlFor="vorname">
          Vorname
        </label>
        <div className="form-field">
          <TextField
            id="vorname"
            name="vorname"
            fullWidth
            className={classes.root}
            value={this.state.vorname}
            onChange={this.updateStateDefault}
            variant="outlined"
          />
          <div className="errorMsg">{this.state.vornameErrorMsg}</div>
        </div>

        <label className="required" htmlFor="nachname">
          Nachname
        </label>
        <div id="containername" className="form-field">
          <TextField
            id="nachname"
            name="nachname"
            fullWidth
            className={classes.root}
            value={this.state.nachname}
            onChange={this.updateStateDefault}
            variant="outlined"
          />
          <div className="errorMsg">{this.state.nachnameErrorMsg}</div>
        </div>

        <label className="required" htmlFor="email">
          E-Mail
        </label>
        <div id="containeremail" className="form-field">
          <TextField
            id="email"
            name="email"
            fullWidth
            className={classes.root}
            value={this.state.email}
            onChange={this.updateStateEmail}
            variant="outlined"
          />
          <div className="errorMsg">{this.state.emailErrorMsg}</div>
        </div>

        <label htmlFor="tel">Telefon</label>
        <div id="containertel" className="form-field">
          <TextField
            id="tel"
            name="tel"
            fullWidth
            className={classes.root}
            value={this.state.tel}
            onChange={this.updateStateDefault}
            variant="outlined"
          />
        </div>

        <label htmlFor="kommune">
          Zuständige Behörde
        </label>
        <div id="containercontactkommune" className="form-field">
          <TextField
            id="kommune"
            name="kommune"
            fullWidth
            className={classes.root}
            value={this.state.kommune}
            onChange={this.updateStateDefault}
            variant="outlined"
          />
        </div>

        <label htmlFor="msgtext">Anliegen</label>
        <div id="containeranliegen" className="form-field">
          <TextField
            id="msgtext"
            name="msgtext"
            multiline
            fullWidth
            minRows={4}
            onChange={this.handleInputChange}
            classes={{ root: classes.root }}
            maxLength="10"
            variant="outlined"
          />
        </div>

        <div id="honey" style={{ display: "none" }}>
          <TextField
            id="honey"
            name="honey"
            onChange={this.handleInputChange}
            value={this.state.honey}
            variant="outlined"
          />
        </div>

        <FileUploader className="form-field" />
        <CheckboxPanel value="data" update={this.updateStateCheckbox} />

        <div className="app-button-container">
          <ServiceBWTooltip
            disableHoverListener={this.state.active}
            title=" Damit Sie Ihre Nachricht absenden können, müssen Sie alle Pflichtfelder (mit * markiert) ausfüllen."
            aria-label=" Damit Sie Ihre Nachricht absenden können, müssen Sie alle Pflichtfelder (mit * markiert) ausfüllen."
          >
            <span className={this.state.active === false ? "" : "navBarOption"}>
              <Button
                className={this.state.active === false ? "button-base button-disabled" : "button-base button-primary"}
                label="Default"
                onClick={this.sendMessageButton}
                value="sende Hilfe"
                disabled={!this.state.active}
                data-testid="sendMessage"
              >
                Absenden
              </Button>
            </span>
          </ServiceBWTooltip>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SupportView);
